import { Component, Input, OnInit, Output, ViewChild, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import * as XLSX from 'xlsx';
import { LocalService, ManagerService, ProfileService } from 'src/app/core';
import { PopupMessageService } from 'src/app/shared/message/services/message.service';
import participation from './participation.json'
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CONSTANTS } from 'src/app/config';
import { AngularEditorConfig } from '@kolkov/angular-editor';
@Component({
  selector: 'app-participation-challenge',
  templateUrl: './participation-challenge.component.html',
  styleUrls: ['./participation-challenge.component.scss']
})
export class ParticipationChallengeComponent implements OnInit {
  fiscalOptionsList: any = [];
  public participationInfoForm!: FormGroup;
  @Input() editChallengeData: any;
  @Input() isCiscoAdmin!: boolean;
  @Input() challengeList: any;
  regionsList = ["USA", "CANADA", "LATAM", "APJ"];
  roleList = [];
  todayDate = new Date();
  beGeoIdsValidationSuccess: boolean = true;
  userProfile: any = null;
  challengeResponse: any;
  typeId: any;
  typeName: any;
  selectedLanguage!: string;
  filteredOptions: Observable<any>[] = [];
  docTypeList: any = [];
  showDupsError: boolean = false;
  readonlyFlag: boolean = false;
  isActiveEdit: boolean = false;
  @Output() submitStatusEvent = new EventEmitter<boolean>();
  budgetSourceList = ['CONTRA', 'OPEX'];
  fiscalYearList: any = [];
  fiscalQuarterList: any = [];
  constructor(private fb: FormBuilder, private managerService: ManagerService, private popupMessageService: PopupMessageService,
    private profileService: ProfileService) { }
  downloadExcelModalOpen = false;
  downloadExcelType = '';

  ngOnInit() {
    console.log(this.editChallengeData)
    this.selectedLanguage = localStorage.getItem('selectedLanguage') as string;
    this.getFiscalOptions();
    this.initaliseForm();
    this.getAllRoles();
    this.userProfile = LocalService.get('userProfile');
    if (this.editChallengeData && this.editChallengeData.id) {
      this.getParticipantsData();
      this.checkInactiveStatus()
    }
    if (this.editChallengeData && this.editChallengeData.isClone) {
      this.challengeResponse = this.editChallengeData;
      this.getparticipationChallengeData(this.editChallengeData)
    }
    this.challengeList.find((x: any) => {
      if (x.id == 6) {
        this.typeId = x.id;
        this.typeName = x.name;
      }
    })
    this.getdocTypeList();
  }


  initaliseForm() {
    this.participationInfoForm = this.fb.group({
      activityName: ['', Validators.required],
      fiscalYear: ['', Validators.required],
      fiscalQuarter: ['', Validators.required],
      startDate: [null, Validators.required],
      endDate: [null, Validators.required],
      acronym: ['', Validators.required],
      description: ['', Validators.required],
      challengeRewards: [null, [Validators.required]],
      partnerCompanies: [[]],
      assignRegion: [[], Validators.required],
      rewardsCap: [null, [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      assignRole: [[], Validators.required],
      selectallUsers: [false],
      tickets: ['', Validators.required],
      proofofCompletion: [false],
      rewardType: ['POINTS', Validators.required],
      visibilityEndDate: [null],
      budgetSource: ['', Validators.required],
      budgetCapByRegionGroup: this.fb.array([]),
      manualDescription: ['']
    })
  }
  setIdentifier() {
    let acronym = "AC- PART";

    let challengeName = '';
    if (this.participationInfoForm.value.fiscalYear && this.participationInfoForm.value.fiscalQuarter.length > 0) {
      let periodStartData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.participationInfoForm.value.fiscalYear
        && x.fiscalQuarter == this.participationInfoForm.value.fiscalQuarter[0])[0]
      let periodEndData = this.fiscalOptionsList.filter((x: any) => x.fiscalYear == this.participationInfoForm.value.fiscalYear
        && x.fiscalQuarter == this.participationInfoForm.value.fiscalQuarter[this.participationInfoForm.value.fiscalQuarter.length - 1])[0]
      const sd = new Date(periodStartData.startDate);
      const ed = new Date(periodEndData.endDate);
      const startDate = new Date(sd.getUTCFullYear(), sd.getUTCMonth(), sd.getUTCDate());
      const endDate = new Date(ed.getUTCFullYear(), ed.getUTCMonth(), ed.getUTCDate());

      this.participationInfoForm.controls.startDate.setValue(startDate);
      this.participationInfoForm.controls.endDate.setValue(endDate);
    }

    if (this.participationInfoForm.value.activityName) {
      this.participationInfoForm.value.activityName.split(" ").filter((e: any) => e.trim()).forEach((x: any) => {
        challengeName += x.charAt(0).toUpperCase();
      });
    }
    let yearVal;
    if (this.participationInfoForm.value.fiscalYear) {
      yearVal = this.participationInfoForm.value.fiscalYear;
    }
    let quarterVal;
    if (this.participationInfoForm.value.fiscalQuarter) {
      quarterVal = this.participationInfoForm.value.fiscalQuarter[this.participationInfoForm.value.fiscalQuarter.length - 1];
    }
    if (challengeName) {
      acronym = acronym + '-' + challengeName
    }
    if (quarterVal) {
      acronym = acronym + '-' + quarterVal
    }
    if (yearVal) {
      acronym = acronym + yearVal
    }
    this.participationInfoForm.controls.acronym.setValue(acronym);
  };
  getFiscalOptions() {
    this.managerService.getActivityFiscalOptions().subscribe((data: any) => {
      data.forEach((element: any) => {
        element.startDate = new Date(element.startDate).toISOString()
        element.endDate = new Date(element.endDate).toISOString()
      });
      this.fiscalOptionsList = data;
      this.fiscalYearList = Array.from(new Set(data.map((x: any) => x.fiscalYear)));
      this.fiscalQuarterList = Array.from(new Set(data.map((x: any) => x.fiscalQuarter)));
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };
  compare(val1: any, val2: any) {
    if (val1 && val2) {
      return val1.id === val2.id;
    }
  }
  onPartnerCompaniesFileSelected(rows: any[]) {
    if (!rows || rows.length === 0) {
      return;
    }
    const columnsName = Object.keys(rows[0]);
    const begeoIdList: string[] = rows.map((val: any) => val[columnsName[0]].toString());
    this.participationInfoForm.controls.partnerCompanies.setValue(begeoIdList);
  }
  getAllRoles() {
    this.profileService.getAllRoles().subscribe((data: any) => {
      if (data) {
        this.roleList = data;
      }
    })
  };
  getSelectedRoleObjects(): any[] {
    const selectedIds = this.participationInfoForm.get('assignRole')!.value || [];
    return this.roleList.filter((role: any) => selectedIds.includes(role.id));
  }

  onRoleSelectionChange(selectedRoles: any[]) {
    const roleIds = selectedRoles.map((role: any) => role.id);
    this.participationInfoForm.get('assignRole')!.setValue(roleIds);
  }
  partnerCompaniesClear() {
    this.participationInfoForm.controls.partnerCompanies.setValue([]);
  }

  begeoIdModalOpen = false;
  begeoIdColumns = [{ field: 'begeoId', header: 'BeGeoId' }];

  get begeoIdRows(): any[] {
    const values = this.participationInfoForm.controls.partnerCompanies.value || [];
    return values.map((item: any, i: number) => ({ begeoId: (i + 1) + '. ' + item }));
  }

  openProductDialogContent(i: any) {
    this.begeoIdModalOpen = true;
  }

  closeBegeoIdModal() {
    this.begeoIdModalOpen = false;
  }
  showDownloadExcelFormatDialog(): void {
    this.downloadExcelType = 'BEGEOID';
    this.downloadExcelModalOpen = true;
  }

  closeDownloadExcelModal(): void {
    this.downloadExcelModalOpen = false;
  }

  downloadExcel(): void {
    let columnData = [];
    if (this.downloadExcelType === 'BEGEOID') {
      columnData = [['BEGEOID']];
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      columnData = [['END CUSTOMER GLOBAL HQ ID']];
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      columnData = [['PRODUCT', 'TYPE', 'PAYOUT']];
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      columnData = [['PRODUCT']];
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      columnData = [['PRODUCT', 'TYPE']];
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      columnData = [['PRODUCT SKUS']];
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      columnData = [['PRODUCT FAMILIES']];
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      columnData = [['USER', 'TARGET']];
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      columnData = [['BEGEOID', 'TARGET']];
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      columnData = [['USERIDS']];
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      columnData = [['BEGEOIDS']];
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      columnData = [['CCOID', 'Date of completion (MM/DD/YYYY)']];
    } else {
      return;
    }
    let workbook = XLSX.utils.book_new(),
      worksheet = XLSX.utils.aoa_to_sheet(columnData);
    workbook.SheetNames.push('First');
    workbook.Sheets['First'] = worksheet;
    let xlsbin = XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' });
    let buffer = new ArrayBuffer(xlsbin.length),
      array = new Uint8Array(buffer);
    for (let i = 0; i < xlsbin.length; i++) {
      array[i] = xlsbin.charCodeAt(i) & 0xff;
    }
    let xlsblob = new Blob([buffer], { type: 'application/octet-stream' });
    let url = window.URL.createObjectURL(xlsblob),
      anchor = document.createElement('a');
    anchor.href = url;
    if (this.downloadExcelType === 'BEGEOID') {
      anchor.download = 'BEGEOID_LIST.xlsx';
    } else if (this.downloadExcelType === 'END_CUSTOMER_ID') {
      anchor.download = 'END_CUSTOMER_LIST.xlsx';
    } else if (this.downloadExcelType === 'INDIVIDUAL_PRODUCT_LIST') {
      anchor.download = 'PRODUCT_PAYOUTS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_LIST') {
      anchor.download = 'PRODUCT_LIST.xlsx';
    } else if (this.downloadExcelType === 'EXCEL_MERGE') {
      anchor.download = 'PRODUCT_LIST_ANY_PRODUCT.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_SKUS') {
      anchor.download = 'PRODUCT_SKUS.xlsx';
    } else if (this.downloadExcelType === 'PRODUCT_FAMILIES') {
      anchor.download = 'PRODUCT_FAMILIES.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_INDIVIDUAL') {
      anchor.download = 'TARGETS_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'TARGETS_COMPANY') {
      anchor.download = 'TARGETS_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_INDIVIDUAL') {
      anchor.download = 'PARTICIPANT_INDIVIDUAL.xlsx';
    } else if (this.downloadExcelType === 'PARTICIPANT_COMPANY') {
      anchor.download = 'PARTICIPANT_COMPANY.xlsx';
    } else if (this.downloadExcelType === 'UPLOAD_COMPLETION') {
      anchor.download = 'Participation Challenge Completions Upload.xlsx';
    }
    anchor.click();
    window.URL.revokeObjectURL(url);
  }
  checkBegeoIdValid() {
    if (this.isCiscoAdmin) {
      if (!(this.participationInfoForm.value.partnerCompanies && this.participationInfoForm.value.partnerCompanies.length)) {
        return true
      }
      let begeoIds = this.participationInfoForm.value.partnerCompanies.toString();
      let regex = /^\d+(?:,\d+)*$/;
      return regex.test(begeoIds);
    } else {
      return true;
    }
  }
  onFormSubmit() {
    let dupsExist = false;
    if (this.participationInfoForm.get('proofofCompletion')!.value) {
      dupsExist = this.checkDuplicateDocuments();
    }
    if (dupsExist) {
      this.showDupsError = true;
      return
    }
    this.showDupsError = false;
    this.beGeoIdsValidationSuccess = this.checkBegeoIdValid();
    if (!this.beGeoIdsValidationSuccess) {
      return;
    } else {
      let challengeFormData = this.participationInfoForm.value;
      let payloadJson = JSON.parse(JSON.stringify(participation));
      payloadJson.name = challengeFormData.activityName;
      payloadJson.startDate = new Date(challengeFormData.startDate).toISOString();
      payloadJson.completeBy = new Date(challengeFormData.endDate).toISOString();
      payloadJson.regions = challengeFormData.assignRegion || [];
      payloadJson.roleIds = challengeFormData.assignRole || [];
      payloadJson.beGeoIds = challengeFormData.partnerCompanies || [];
      payloadJson.description = challengeFormData.description.replace(/&#160;/g, "");
      payloadJson.acronym = challengeFormData.acronym;
      payloadJson.credits = challengeFormData.rewardType === 'CREDITS' ? Number(challengeFormData.tickets) : null;
      payloadJson.points = challengeFormData.rewardType === 'POINTS' ? Number(challengeFormData.tickets) : null;
      payloadJson.userIds = challengeFormData.assignPeople;
      payloadJson.winnersCount = challengeFormData.noOfPeople;
      payloadJson.managerId = this.userProfile.id;
      payloadJson.status = this.editChallengeData == null ? 'DRAFT' : this.challengeResponse.status;
      payloadJson.fiscalYear = challengeFormData.fiscalYear;
      payloadJson.fiscalQuarters = challengeFormData.fiscalQuarter;
      payloadJson.winnersCount = challengeFormData.rewardsCap;
      payloadJson.challengeRewards = challengeFormData.challengeRewards.replace(/&#160;/g, "");
      payloadJson.typeId = this.typeId;
      payloadJson.typeName = this.typeName;
      payloadJson.creatorType = "CISCO_ADMIN";
      payloadJson.requiredUploadDocuments = challengeFormData.proofofCompletion;
      if (challengeFormData.proofofCompletion) {
        payloadJson.documents = challengeFormData.proofOfCompletionGroup.map((x: any) => {
          return {
            id: x.id,
            name: x.proofName,
            requiredApproval: x.proofApproval
          }
        })
      } else {
        payloadJson.documents = [];
      };
      payloadJson.rewardType = challengeFormData.rewardType;
      payloadJson.visibilityEndDate = challengeFormData.visibilityEndDate && new Date(challengeFormData.visibilityEndDate).toISOString();
      payloadJson.budgetSource = challengeFormData.budgetSource;
      payloadJson.budgetCaps = this.getBudgetCapsData(challengeFormData);
      payloadJson.manualDescription = challengeFormData.manualDescription
        ? challengeFormData.manualDescription.replace(/&#160;/g, "")
        : challengeFormData.manualDescription;
      if (this.isCiscoAdmin) {
        payloadJson.category = "SPECIAL_ACTIVITY"
      }
      if (this.editChallengeData && this.editChallengeData.id) {
        payloadJson.id = this.editChallengeData.id;
        this.managerService.updateParticipantsData(payloadJson).subscribe((data: any) => {
          if (data) {
            this.popupMessageService.showSuccess('Participation challenge updated successfully', 'success');
            this.participationInfoForm.reset();
            this.editChallengeData = null;
            this.submitStatusEvent.emit(true);
          };
        },
          (_err: any) => {
            this.popupMessageService.showError('Something went wrong', 'error');
          });
      } else {
        this.managerService.createParticipantsChallenge(payloadJson).subscribe((data: any) => {
          if (data) {
            this.popupMessageService.showSuccess('Participation challenge updated successfully', 'success');
            this.participationInfoForm.reset();
            this.editChallengeData = null;
            this.submitStatusEvent.emit(true);
          }
        },
          (_err: any) => {
            this.popupMessageService.showError('Something went wrong', 'error');
          });

      }

    }
  }

  getTickets(response: any) {
    let noOfTickets = null;
    if (response && response.rewardType === 'CREDITS') {
      noOfTickets = response.credits;
    }
    if (response && response.rewardType === 'POINTS') {
      noOfTickets = response.points;
    }
    return noOfTickets;
  };

  getParticipantsData() {

    this.managerService.getParticipantsChallengeById(this.editChallengeData.id).subscribe((response: any) => {
      this.challengeResponse = response.body;
      if (response) {
        let responseData = response.body;
        this.getparticipationChallengeData(responseData)
      }
    })
  };

  getdocTypeList() {
    this.managerService.getDocTypeList().subscribe((data: any) => {
      this.docTypeList = data;
    }, (_err: any) => {
      this.popupMessageService.showError('Something went wrong', 'error');
    });
  };

  onProofofCompletionChange(event: any) {
    if (event.target.checked) {
      this.participationInfoForm.addControl('proofOfCompletionGroup', this.fb.array([this.createproofOfCompletionArray()]))
      this.manageFilteredOptionsList(0)
    } else {
      this.participationInfoForm.removeControl('proofOfCompletionGroup')
    }
  };

  createproofOfCompletionArray() {
    return this.fb.group({
      id: [null],
      proofName: ["", Validators.required],
      proofApproval: [false, Validators.required]
    })
  };

  updateProofOfCompletionArray(documentList: any) {
    let updatedArrayList: any[] = [];
    documentList.forEach((proofData: any) => {
      updatedArrayList.push(this.fb.group({
        id: [proofData.id],
        proofName: [proofData.name, Validators.required],
        proofApproval: [proofData.requiredApproval, Validators.required]
      }))
    });
    return updatedArrayList;
  }

  getProofOfCompletionGroup(form: any) {
    return form.controls.proofOfCompletionGroup ? form.controls.proofOfCompletionGroup.controls : null;
  };

  addProofOfCompletionGroup() {
    const control = <FormArray>this.participationInfoForm.get('proofOfCompletionGroup');
    control.push(this.createproofOfCompletionArray());
    this.manageFilteredOptionsList(control.length - 1)
  };

  removeProofOfCompletionGroup(index: any) {
    const control = <FormArray>this.participationInfoForm.get('proofOfCompletionGroup');
    control.removeAt(index);
    this.filteredOptions.splice(index, 1);
  };

  manageFilteredOptionsList(index: number) {
    const arrayControl = this.participationInfoForm.get('proofOfCompletionGroup') as FormArray;
    this.filteredOptions[index] = arrayControl.at(index).get('proofName')!.valueChanges.pipe(
      startWith<any>(''),
      map((value: any) => typeof value === 'string' ? value : value.name),
      map((name: any) => name ? this._filter(name) : this.docTypeList.slice())
    );
  };

  private _filter(name: any) {
    const filterValue = name.toLowerCase();
    return this.docTypeList.filter((option: any) => option.name.toLowerCase().indexOf(filterValue) === 0);
  };

  displayFn(option: any): string | undefined {
    return option ? (typeof (option) === 'string' ? option : option.name) : undefined;
  };

  checkDuplicateDocuments() {
    let dupsExist = false;
    const documentsList = this.participationInfoForm.get('proofOfCompletionGroup')!.value.map((x: any) => x.proofName);
    if (new Set(documentsList).size !== documentsList.length) {
      dupsExist = true;
    }
    return dupsExist;
  }

  addBudgetCapPerRegionGroup(region: any) {
    return this.fb.group({
      region: [region],
      budgetCap: ['', [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [''],
      id: [''],
      modifiedBy: ['']
    })
  };

  updateBudgetCapPerRegionGroup(budget: any) {
    return this.fb.group({
      region: [budget.region],
      budgetCap: [budget.amount, [Validators.required, Validators.pattern(CONSTANTS.regex.notZero)]],
      createdBy: [budget.createdBy],
      id: [budget.id],
      modifiedBy: ['']
    })
  };

  get budgetCapByRegionGroupArray(): FormArray {
    return <FormArray>this.participationInfoForm.get('budgetCapByRegionGroup');
  };

  setBudgetCapData(res: any) {
    let budgetData: any[] = []
    if (res.rewardType === 'POINTS') {
      res.budgetCaps.forEach((budget: any) => {
        budgetData.push(this.updateBudgetCapPerRegionGroup(budget));
      })
    }
    return budgetData
  };

  getBudgetCapsData(formData: any) {
    let budgetCapData: any[] = [];
    if (formData.rewardType === 'POINTS') {
      budgetCapData = formData.budgetCapByRegionGroup.map((budgetRegion: any, index: number) => {
        return {
          activityBudgetCapType: "BUDGETCAP_REGIONAL",
          amount: budgetRegion.budgetCap,
          region: budgetRegion.region,
          id: budgetRegion.id || '',
          createdBy: budgetRegion.createdBy || this.userProfile.id,
          modifiedBy: this.editChallengeData ? this.userProfile.id : ''
        }
      })
    }
    return budgetCapData;
  };

  onRegionSelection(challengeData: any = null) {
    if (this.participationInfoForm.controls.rewardType.value === 'POINTS') {
      const selectedRegions: string[] = this.participationInfoForm.get('assignRegion')!.value || [];
      this.regionsList.forEach((region: string) => {
        const index = this.budgetCapByRegionGroupArray.value.findIndex((budget: any) => budget.region === region);
        const isSelected = selectedRegions.includes(region);
        if (isSelected && index === -1) {
          this.budgetCapByRegionGroupArray.push(this.addBudgetCapPerRegionGroup(region));
        }
        if (!isSelected && index > -1) {
          this.budgetCapByRegionGroupArray.removeAt(index);
        }
      });

      this.participationInfoForm.get('budgetSource')!.setValidators([Validators.required]);
      this.participationInfoForm.get('budgetSource')!.updateValueAndValidity();
    } else {
      this.participationInfoForm.get('budgetSource')!.setValue(null);
      this.participationInfoForm.get('budgetSource')!.clearValidators();
      this.participationInfoForm.get('budgetSource')!.updateValueAndValidity();
      while (this.budgetCapByRegionGroupArray.value.length) {
        this.budgetCapByRegionGroupArray.removeAt(0);
      }
    }

    if (
      this.participationInfoForm.controls.rewardType.value === 'POINTS' ||
      this.participationInfoForm.controls.rewardType.value === 'CREDITS'
    ) {
      this.participationInfoForm.get('tickets')!.setValue(this.getTickets(challengeData) || '');
      this.participationInfoForm.get('tickets')!.setValidators([Validators.required]);
      this.participationInfoForm.get('tickets')!.updateValueAndValidity();

      this.participationInfoForm.get('manualDescription')!.setValue(null);
      this.participationInfoForm.get('manualDescription')!.clearValidators();
      this.participationInfoForm.get('manualDescription')!.updateValueAndValidity();
    } else {
      this.participationInfoForm.get('tickets')!.setValue(null);
      this.participationInfoForm.get('tickets')!.clearValidators();
      this.participationInfoForm.get('tickets')!.updateValueAndValidity();

      this.participationInfoForm.get('manualDescription')!.setValue(challengeData && challengeData.manualDescription || '');
      this.participationInfoForm.get('manualDescription')!.setValidators([Validators.required]);
      this.participationInfoForm.get('manualDescription')!.updateValueAndValidity();
    }
  };

  resetForm() {
    this.participationInfoForm.removeControl('proofOfCompletionGroup');
    if (this.editChallengeData) {
      this.getParticipantsData();
    } else {
      this.participationInfoForm.reset();
    }
    this.participationInfoForm.patchValue({ 'rewardType': 'POINTS' })
    while (this.budgetCapByRegionGroupArray.value.length) {
      this.budgetCapByRegionGroupArray.removeAt(0);
    }
  };
  getparticipationChallengeData(responseData: any) {
    this.participationInfoForm.patchValue({ 'activityName': responseData.name });
    this.participationInfoForm.patchValue({ 'startDate': new Date(responseData.startDate) });
    this.participationInfoForm.patchValue({ 'endDate': new Date(responseData.completeBy) });
    this.participationInfoForm.patchValue({ 'acronym': responseData.acronym });
    this.participationInfoForm.patchValue({ 'assignRegion': responseData.regions });
    this.participationInfoForm.patchValue({ 'assignRole': responseData.roleIds });
    this.participationInfoForm.patchValue({ 'partnerCompanies': responseData.beGeoIds });
    this.participationInfoForm.patchValue({ 'description': responseData.description });
    this.participationInfoForm.patchValue({ 'minEligibleAmt': responseData.architectureBookingsToBeSold });
    this.participationInfoForm.patchValue({ 'tickets': this.getTickets(responseData) });
    this.participationInfoForm.patchValue({ 'assignPeople': responseData.userIds });
    this.participationInfoForm.patchValue({ 'noOfPeople': responseData.winnersCount });
    this.participationInfoForm.patchValue({ 'fiscalYear': responseData.fiscalYear });
    this.participationInfoForm.patchValue({ 'fiscalQuarter': responseData.fiscalQuarters });
    this.participationInfoForm.patchValue({ 'rewardsCap': responseData.winnersCount > 0 ? responseData.winnersCount : null });
    this.participationInfoForm.patchValue({ 'challengeRewards': responseData.challengeRewards });
    this.participationInfoForm.patchValue({ 'proofofCompletion': responseData.requiredUploadDocuments });
    if (responseData.requiredUploadDocuments) {
      this.participationInfoForm.addControl(
        'proofOfCompletionGroup',
        this.fb.array(this.updateProofOfCompletionArray(responseData.documents))
      )
      responseData.documents.forEach((_: any, index: number) => this.manageFilteredOptionsList(index))
    };
    this.participationInfoForm.patchValue({ 'rewardType': responseData.rewardType });
    this.participationInfoForm.patchValue({
      'visibilityEndDate': responseData.visibilityEndDate ? new Date(responseData.visibilityEndDate) : null
    });
    this.participationInfoForm.patchValue({ 'budgetSource': responseData.budgetSource });
    this.participationInfoForm.setControl('budgetCapByRegionGroup', this.fb.array(this.setBudgetCapData(responseData)));
    this.participationInfoForm.patchValue({ 'manualDescription': responseData.manualDescription });
    this.onRegionSelection(responseData)
  }
  checkInactiveStatus() {
    const q = new Date();
    const m = q.getMonth();
    const d = q.getDate();
    const y = q.getFullYear();

    const todayDate = new Date(y, m, d);

    const mydate = new Date(this.editChallengeData.completeBy);


    if ((todayDate > mydate) && this.editChallengeData.status === 'INACTIVE') {
      this.readonlyFlag = true;
    } else {
      this.readonlyFlag = false;
    }

  }
  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '150px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '350px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

  };
  rewardEditorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: '97px',
    minHeight: '0',
    maxHeight: 'auto',
    width: '354px',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    sanitize: true,
    toolbarPosition: 'top',

  };
}
